import React from 'react';

import Tippy from '@tippyjs/react';
import HelpIcon from 'src/assets/icons/help_icon.svg';
import styles from './index.css';
import { HyperLink, Paragraph, Span } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

class Tooltip extends React.Component {
	render() {
		const { urlDescription, urlPath, name, spanStyle } = this.props;
		const urlBase = 'https://intercom.help/wiselysupport/en/articles/';
		const content = this.props.content || (
			<Paragraph fontSize={theme.fontSizes[4]}>
				Need help? Check out{' '}
				<HyperLink href={urlBase + urlPath} target="_blank" rel="noopener noreferrer">
					this <br />
					{urlDescription}
				</HyperLink>{' '}
				about the
				<br /> {name}.{' '}
			</Paragraph>
		);

		return (
			<Tippy
				content={content}
				interactive={true}
				interactiveBorder={10}
				className={styles.Bubble}
			>
				<Span tabIndex="0" {...spanStyle}>
					<HelpIcon style={{ width: '20px', height: '20px' }} />
				</Span>
			</Tippy>
		);
	}
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js